import { ArrowLeft } from '@/components/icons';
import { Button } from '../ui/button';
import { ReactNode } from 'react';
import { useBackOrHome } from './useBackOrHome';

interface TopBarBackButtonProps {
  title: ReactNode;
  rightElement?: ReactNode;
  onBack?: () => void;
  disableBack?: boolean;
}

export function TopBarBackButton({
  title,
  rightElement,
  onBack,
  disableBack,
}: TopBarBackButtonProps) {
  const backOrHome = useBackOrHome()
  const handleBack = onBack ?? backOrHome

  return (
    <>
      {/* Spacer to reserve space in document flow — must match fixed header height */}
      <div className="shrink-0 bg-surface-brand-L0 safe-top">
        <div className="h-16" />
      </div>
      {/* Fixed header */}
      <div className="bg-transparent fixed top-0 left-0 right-0 z-50 safe-top">
        <div className="content-frame px-gutter py-4 flex items-center justify-between">
          {/* Left: Back Button + Title */}
          <div className="flex items-center gap-3">
            <Button
              variant="secondary"
              size="sm"
              roundness="round"
              onClick={handleBack}
              disabled={disableBack}
              className="border-none size-8 p-0 bg-surface-L2 hover:bg-surface-L0/80"
            >
              <ArrowLeft className="size-5" />
            </Button>
            <h1 className="text-content-primary-bold text-xl font-semibold">
              {title}
            </h1>
          </div>

          {/* Right: parent-provided action (fully styled by caller) */}
          {rightElement}
        </div>
      </div>
    </>
  );
}
